const orderServe = () => import('@/views/main/order/serve/serve.vue')
export default {
  path: '/main/order/serve',
  name: 'orderServe',
  component: orderServe,
  children: []
}
